<cm-contract-widget *ngIf="objectIdentifier"  [objectIdentifier]="objectIdentifier"></cm-contract-widget>
<cm-contract-person-object-widgets
        *ngIf="customer && contract"
        [customerDto]="customer"
        [contractDto]="contract">
</cm-contract-person-object-widgets>
<cm-contract-service *ngIf="objectIdentifier"
                     [objectIdentifier]="objectIdentifier"
></cm-contract-service>
<cm-document-component *ngIf="objectIdentifier"
                       [objectIdentifier]="objectIdentifier"
></cm-document-component>
<cm-former-contract *ngIf="customer && contract"
                    [contractDto]="contract"
                    [customerDto]="customer"
> </cm-former-contract>
<cm-comment-component *ngIf="objectIdentifier"
                      [objectIdentifier]="objectIdentifier"
></cm-comment-component>

